export default "__VITE_ASSET__D2gjP2vv__"